import { render, staticRenderFns } from "./MessageOwn.vue?vue&type=template&id=0b88765f&"
import script from "./MessageOwn.vue?vue&type=script&lang=js&"
export * from "./MessageOwn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports